<mat-form-field *ngIf="initialized" style="width: 100%;">
  <mat-label>{{field.title}}</mat-label>
  <mat-select [formControl]="formControl">
    <mat-option *ngIf="!field.required" [value]="null"><i>Nezadáno</i></mat-option>
    <mat-option *ngFor="let option of values"
                [value]="option[observableField.optionValue]"
                [matTooltip]="option[observableField.optionName]"
                matTooltipPosition="right">
      {{option[observableField.optionName]}}
    </mat-option>
  </mat-select>
  <mat-error>{{errorMessage}}</mat-error>
</mat-form-field>
